import styled from '@mui/styles/styled';

export default styled('div')(({ theme }) => ({
	margin: `${theme.spacing()}px 0`,
}));
